import type { BentoGridItem, HeroSlide, ProductDiscoveryConfig } from './home.types'

export const featuredCategories = [
  { label: 'New Arrivals', value: 'new-arrivals', href: '/browse?type=new-arrivals' },
  { label: 'Top Purchased', value: 'top-purchased', href: '/browse?type=top-purchased' },
  { label: 'Limited Stock', value: 'limited-stock', href: '/browse?type=limited-stock' },
  { label: 'Recommended', value: 'recommended', href: '/browse?type=recommended' },
  { label: 'Mouth Watering', value: 'mouth-watering', href: '/browse?type=mouth-watering' },
]

export const heroSlides: HeroSlide[] = [
  {
    id: '1',
    image_url: 'https://images.unsplash.com/photo-1558060370-d644479cb6f7?w=600&q=40&auto=format',
    headline: 'Dream, Play, Explore',
    description:
      'Discover a world of wonder with our captivating toys. From cuddly companions to action-packed adventures, our toys are designed to spark creativity, inspire learning, and bring joy to every playtime.',
    cta_text: 'Shop now',
    nav_type: 'browse',
    nav_value: 'toys',
    tracking_id: 'hero_toys_jan2026',
  },
  {
    id: '2',
    image_url: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600&q=40&auto=format',
    headline: 'New Year, New Style',
    description:
      'Refresh your wardrobe with the latest fashion trends. Discover curated collections that blend comfort with style for every occasion.',
    cta_text: 'Explore fashion',
    nav_type: 'browse',
    nav_value: 'fashion-traditional-wear',
    tracking_id: 'hero_fashion_jan2026',
  },
  {
    id: '3',
    image_url: 'https://images.unsplash.com/photo-1468495244123-6c6c332eeece?w=600&q=40&auto=format',
    headline: 'Tech That Transforms',
    description:
      'Experience cutting-edge electronics that enhance your everyday life. From smart devices to entertainment systems, find your next upgrade.',
    cta_text: 'Shop electronics',
    nav_type: 'browse',
    nav_value: 'electronics',
    tracking_id: 'hero_electronics_jan2026',
  },
  {
    id: '4',
    image_url: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&q=40&auto=format',
    headline: 'Kitchen Essentials Sale',
    description:
      'Up to 50% off on premium cookware, appliances, and gadgets. Transform your kitchen into a culinary paradise.',
    cta_text: 'View deals',
    nav_type: 'search',
    nav_value: 'kitchen deals',
    tracking_id: 'hero_kitchen_sale_jan2026',
  },
]

export const bentoGridItems: BentoGridItem[] = [
  {
    id: 'featured-1',
    title: 'Flavours of Home',
    image: '/images/bento/flavours.webp',
    ctaText: 'Shop Spices & Grocery',
    navType: 'browse',
    navValue: 'food-grocery',
    trackingParams: {
      pd_rd_w: 'w1x2y3',
      pd_rd_wg: 'bentoMain',
      pd_rd_r: 'abc123def',
    },
  },
  {
    id: 'featured-2',
    title: 'Beauty & Wellness',
    image: '/images/bento/beauty.jpg',
    ctaText: 'Shop Natural Beauty',
    navType: 'browse',
    navValue: 'beauty-wellness-personal-care',
    trackingParams: {
      pd_rd_w: 'a4b5c6',
      pd_rd_wg: 'bentoWide',
      pd_rd_r: 'xyz789ghi',
    },
  },
  {
    id: 'featured-3',
    title: 'Heritage & Threads',
    image: '/images/bento/fashion.webp',
    ctaText: 'Explore Cultural Fashion',
    navType: 'browse',
    navValue: 'fashion-traditional-wear',
    trackingParams: {
      pd_rd_w: 'd7e8f9',
      pd_rd_wg: 'bentoSmall1',
      pd_rd_r: 'jkl456mno',
    },
  },
  {
    id: 'featured-4',
    title: 'Thoughtful & Cultural Gifts',
    image: '/images/bento/gifts.jpg',
    ctaText: 'Shop Cultural Gifts',
    navType: 'browse',
    navValue: 'gifts-occasions',
    trackingParams: {
      pd_rd_w: 'g1h2i3',
      pd_rd_wg: 'bentoSmall2',
      pd_rd_r: 'pqr789stu',
    },
  },
]

// Discovery Section Configs
export const recentlyViewedConfig: ProductDiscoveryConfig = {
  title: 'Recently Viewed Products',
  widgetType: 'recently_viewed',
  defaultLayout: 'carousel',
  showLayoutToggle: true,
}
